export const PAGE_IDS = {
  TASKS_HOME: 'TASKS_HOME_PAGE',
  LEGACY_BOARD: 'LEGACY_BOARD_PAGE'
};